import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './utils/locales/en.json';
import es from './utils/locales/es.json';
import useConfig from 'hooks/useConfig';
const useI18n = () => {
    const { locale, ready } = useConfig();
    if (ready) {
        i18n.use(initReactI18next).init({
            resources: {
                en: { translation: en },
                es: { translation: es }
            },
            lng: locale, // Default language
            fallbackLng: 'en',
            interpolation: { escapeValue: false }
        });
    }
    return i18n;
};

export default useI18n;
